import EntityListView from '@/views/EntityListView.vue';
export default [
   {
    path: '/list-view-drawer/:type',
    name: 'EntityListView',
    component: EntityListView,
    meta: {
      requiresAuth: true 
    }
  }
];